export default [{
  path: '/departman',
  name: 'departman',
  component: () => import('@/views/ayarlar/departman.vue'),
}, {
  path: '/kullanicilar',
  name: 'kullanicilar',
  component: () => import('@/views/ayarlar/kullanicilar.vue'),
}]
